import { createSelector } from "reselect";

const selectDashboardState = (state) => state.dashboard;

export const selectDashboardById = createSelector(
    [selectDashboardState, (_, id) => id],
    (dashboard, id) => dashboard[id] || {}
);

